export default "__VITE_ASSET___OQ1o$mf__"